import { render, staticRenderFns } from "./ReleaseButton.vue?vue&type=template&id=9ea15002"
import script from "./ReleaseButton.vue?vue&type=script&lang=ts"
export * from "./ReleaseButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports